import './PricesRequest.scss';

import React from 'react';
import { useTranslation } from 'react-i18next';

import PricesRequestForm from '@/ebat/components/blocks/Account/Informations/PricesRequestForm/PricesRequestForm';

import {
  PricesRequestDefaultProps,
  PricesRequestPropTypes,
} from './PricesRequest.proptypes';

const PricesRequest = ({ user }) => {
  const { t } = useTranslation();

  return (
    <div
      className="modal-prices-request__content"
      data-qa-id="modal-prices-request"
    >
      <h1 className="rs-modal-title">
        {t('ebat:entities:account.informations.ask_price_file')}
      </h1>
      <PricesRequestForm user={user} />
    </div>
  );
};

PricesRequest.defaultProps = {
  ...PricesRequestDefaultProps,
};

PricesRequest.propTypes = {
  ...PricesRequestPropTypes,
};

export default PricesRequest;
